import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { AwardingConfigurationQuery, TsrctDemandAwardingRuleVariant } from '@/generated/gql/graphql';

// Built on tesseract's own rule variants, not the shared @procureai/schemas awarding config: that one
// is shaped for core and dropped the PREFERRED_SUPPLIER variants and the deadline (APP-6467), which
// tesseract still stores and applies (BUG-3658).
export const awardingConfigurationFormSchema = z.object({
  rules: z
    .array(
      z.object({
        variant: z.enum(TsrctDemandAwardingRuleVariant),
      }),
    )
    .min(1),
  deadline: z.object({
    days: z.number().min(1),
  }),
  automation: z.object({
    enabled: z.boolean(),
  }),
});

export type AwardingConfigurationFormData = z.infer<typeof awardingConfigurationFormSchema>;

type StoredAwardingConfiguration = AwardingConfigurationQuery['tesseract']['demand']['awardingConfiguration'];

export const toAwardingConfigurationFormData = (
  configuration: Pick<StoredAwardingConfiguration, 'deadlineDays' | 'performAutomaticAwarding'> & {
    rules: Pick<StoredAwardingConfiguration['rules'][number], 'variant'>[];
  },
): DefaultValues<AwardingConfigurationFormData> => ({
  rules: configuration.rules.map(({ variant }) => ({ variant })),
  deadline: {
    days: configuration.deadlineDays || undefined,
  },
  automation: {
    enabled: configuration.performAutomaticAwarding,
  },
});
